"use strict";

/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncTransform = void 0;
exports.isSyncTransform = function (transform) {
  return transform.length === 1;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJleHBvcnRzIiwiaXNTeW5jVHJhbnNmb3JtIiwidHJhbnNmb3JtIiwibGVuZ3RoIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3R5cGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOztBQUFBOzs7OztBQVlhQSxPQUFBLENBQUFDLGVBQWUsR0FBRyxVQUMzQkMsU0FBcUM7RUFBQSxPQUNDQSxTQUFTLENBQUNDLE1BQU0sS0FBSyxDQUFDO0FBQUEifQ==